export class TableContextSameColumns {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "other",
            "baseName": "other",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSameColumns.attributeTypeMap;
    }
    constructor() {
    }
}
